/** Persists/reads a hunt's round content (clue/question/answer/options/hint) from the
 * dedicated `questions` table instead of the generic themesdata key/value blob. */

export async function saveHuntQuestions({ payload, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/saveHuntQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || `Failed to save questions (${resp.status})`);
  }
  return resp.json();
}

export async function fetchHuntQuestions({ payload, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/fetchHuntQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || `Failed to fetch questions (${resp.status})`);
  }
  return resp.json();
}
